import Axios from 'axios';

Axios.defaults.baseURL = 'https://flight.musafirbazar.com/api/';
// Axios.defaults.baseURL = 'https://flight.marinersforex.com/api/';

export const axiosInstance = Axios.create({});
